/**
* One Column Scroll JS
* -----------------------------------------------------------------------------
*
* All the JS for the One Column Scroll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin( CustomEase );
( function( app ) {
  const COMPONENT = {

    className: 'one-column-scroll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.one-column-scroll' ).each( function( key, component ) {
        // get nav heights and whatnot
        const docStyle = getComputedStyle( document.documentElement );
        const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
        const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
        const screenHeight = $( window ).height() + ( $( window ).height() / 2.81 );
        // -------

        // set up some variables
        const originalPanelHeight = $( this ).find( '.one-column-scroll__panel' ).height();
        const speed = 2; // higher is slower
        const panelHeight = originalPanelHeight * ( 1 + ( 0.25 * speed ) );
        const panelsCount = $( this ).find( '.one-column-scroll__panel' ).length;

        if ( panelsCount == 1 ) return;

        // set the height of the component to the desired speed
        $( component ).height( $( component ).find( '.one-column-scroll__panel' ).height() * ( panelsCount + speed ) );

        // pin the component
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            pin: $( component ).find( '.one-column-scroll__panels' )[0],
            start: 'top ' + topOffset,
            end: 'bottom bottom',
            scrub: 0,
          },
        } );

        $( '.one-column-scroll' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 75%',
              scrub: 0.15,
              // markers: true,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'is-loaded' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-active' ),
            },
          } );
        } );

        // scroll to appropriate panel when pagination is clicked
        $( component ).find( '.one-column-scroll__pagination-panel a' ).on( 'click', function() {
          window.scrollTo( {
            top: $( component ).position().top + ( panelHeight * $( this ).index() ) + screenHeight,
            left: 0,
            behavior: 'smooth',
            speed: 10000,
          } );
        } );

        // loop through each panel to set up the revealing of it
        $( component ).find( '.one-column-scroll__panel' ).each( function( panelKey, panel ) {
          // reveal the content
          if ( panelKey > 0 ) {
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: panel,
                start: ( panelHeight * ( panelKey ) ) + ' ' + topOffset,
                end: '+=' + panelHeight,
                scrub: 1,
                onUpdate: ( self ) => {
                  // update the active page when it's related panel is hit
                  if ( ( self.progress > 0.01 && self.progress < 0.99 ) || ( self.progress <= 0.01 && panelKey == 0 ) ) {
                    $( component ).find( '.one-column-scroll__pagination-panel a:nth-child(' + ( panelKey + 1 ) + ')' ).addClass( 'is-active' );
                  } else {
                    $( component ).find( '.one-column-scroll__pagination-panel a:nth-child(' + ( panelKey + 1 ) + ')' ).removeClass( 'is-active' );
                  }
                },
              },
            } );
          }

          const totalPanels = $( '.one-column-scroll__panel' ).length;

          if ( panelKey + 1 == totalPanels ) {
            tl.from( $( this ), {opacity: 0, duration: 1000, pointerEvents: 'none'} )
                .from( $( this ).find( '.one-column-scroll__panel-heading' ), {opacity: 0, translateY: '50px', duration: 1000} )
                .from( $( this ).find( '.one-column-scroll__panel-description, .one-column-scroll__panel-buttons, .one-column-scroll__image' ), {opacity: 0, translateY: '50px', duration: 1000} );
          } else if ( panelKey !== 0 ) {
            tl.from( $( this ), {opacity: 0, duration: 1000, pointerEvents: 'none'} )
                .from( $( this ).find( '.one-column-scroll__panel-heading' ), {opacity: 0, translateY: '50px', duration: 1000} )
                .from( $( this ).find( '.one-column-scroll__panel-description, .one-column-scroll__panel-buttons, .one-column-scroll__image' ), {opacity: 0, translateY: '50px', duration: 1000} );
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'one-column-scroll', COMPONENT );
} )( app );
